
export let successCode = 200;
export let unauthorizedCode = 401;